<div class="grid" *ngIf="previsionMeteo$ | async as previsions">
  <ng-container *ngIf="appMain.isMobile; else desktopView">
    <p-accordion [multiple]="true" class="col-12">
      <p-accordionTab *ngFor="let prevision of previsions">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-3">
            <div class="time-of-day">{{ getTimeOfDay(prevision.date) }}</div>
            <img [src]="getWeatherIconUrl(prevision.icon)" [alt]="prevision.description" class="weather-icon"
              style="width: 32px; height: 32px;">
            <span class="temp-value">{{ prevision.temperature | number:'1.0-0' }}°C</span>
            <span *ngIf="prevision.volumePrecipitation > 0" class="text-sm">
              <i class="pi pi-cloud-rain"></i>
              {{ prevision.probabilitePrecipitation * 100 | number:'1.0-0' }}%
            </span>
          </div>
        </ng-template>
        <div class="weather-main">
          <div class="temperature">
            <span class="feels-like">Ressenti {{ prevision.temperatureRessenti | number:'1.0-0' }}°C</span>
          </div>
        </div>

        <div class="weather-details">
          <div class="detail-item">
            <i class="pi pi-wind"></i>
            <span>{{ prevision.vitesseVent | number:'1.0-0' }} km/h {{ getWindDirection(prevision.directionVent)
              }}</span>
            <span class="gusts" *ngIf="prevision.rafales">(Rafales: {{ prevision.rafales | number:'1.0-0' }}
              km/h)</span>
          </div>

          <div class="detail-item">
            <i class="pi pi-drop"></i>
            <span>Humidité: {{ prevision.humidite | number:'1.0-0' }}%</span>
          </div>

          <div class="detail-item" *ngIf="prevision.volumePrecipitation > 0">
            <i class="pi pi-cloud-rain"></i>
            <span>{{ prevision.typePrecipitation }}: {{ prevision.volumePrecipitation | number:'1.0-1' }}mm</span>
            <span class="probability">(Probabilité: {{ prevision.probabilitePrecipitation * 100 | number:'1.0-0'
              }}%)</span>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </ng-container>

  <ng-template #desktopView>
    <div class="col-12 lg:col-6 xl:col-3 flex align-items-center justify-content-center gap-2 pb-0" *ngFor="let prevision of previsions">
      <div class="flex flex-column align-items-center gap-2">
        <img [src]="getWeatherIconUrl(prevision.icon)" [alt]="prevision.description" class="weather-icon">
      </div>

      <div class="weather-main">
        <div class="temperature">
          <div class="time-of-day">{{ getTimeOfDay(prevision.date) }}</div>
          <span class="temp-value">{{ prevision.temperature | number:'1.0-0' }}°C</span>
          <span class="feels-like">Ressenti {{ prevision.temperatureRessenti | number:'1.0-0' }}°C</span>
        </div>
      </div>

      <div class="weather-details">
        <div class="detail-item">
          <i class="pi pi-wind"></i>
          <span>{{ prevision.vitesseVent | number:'1.0-0' }} km/h {{ getWindDirection(prevision.directionVent) }}</span>
        </div>

        <div *ngIf="prevision.rafales" class="detail-item">
          <span>Rafales: {{ prevision.rafales | number:'1.0-0' }} km/h</span>
        </div>

        <div class="detail-item">
          <i class="pi pi-drop"></i>
          <span>Humidité: {{ prevision.humidite | number:'1.0-0' }}%</span>
        </div>

        <div class="detail-item" *ngIf="prevision.volumePrecipitation > 0">
          <i class="pi pi-cloud-rain"></i>
          <span>{{ prevision.typePrecipitation == 'N' ? 'Neige' : 'Pluie' }}: {{ prevision.volumePrecipitation |
            number:'1.0-1' }}mm</span>
          <span class="probability">(Probabilité: {{ prevision.probabilitePrecipitation * 100 | number:'1.0-0'
            }}%)</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div class="alert-container mb-2" *ngIf="alertData">
  <div class="flex justify-content-between align-items-center mb-2">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-exclamation-triangle"></i>
      <span class="alert-title">Alerte météo</span>
    </div>
    <div class="alert-sender">De: {{ alertData.alerteExpediteur }}</div>
  </div>
  <div class="alert-content">
    <div class="alert-description" [class.expanded]="isAlertDescriptionExpanded" (click)="toggleAlertDescription()"
      title="Cliquez pour voir plus">
      {{ alertData.alerteDescription }}
    </div>
    <div class="alert-period">
      Valide de {{ alertData.alerteDe | date:'yyyy/MM/dd HH:mm' }} à {{ alertData.alerteA | date:'yyyy/MM/dd HH:mm' }}
    </div>
  </div>
</div>

